import React from 'react';
import {
  Card, CardTitle, CardContent, CardActions, Typography, Button
} from '@one-thd/sui-atomic-components';

const PromotionFallback = () => {
  const generatePromoLink = ({ link, img, text }) => {
    return (
      <span>
        <a href={link} className="sui-flex sui-flex-row sui-gap-2">
          <img src={img} height="24" width="24" alt="Promo Icon" />
          <Typography weight="regular">
            {text}
          </Typography>
        </a>
      </span>
    );
  };
  return (
    <Card grow PaperProps={{ className: 'sui-flex sui-h-full' }}>
      <CardTitle header={
        <Typography variant="h3">Specials & Offers</Typography>
      }
      />
      <CardContent className="sui-flex sui-overflow-hidden sui-flex-col sui-justify-between sui-w-full sui-h-full">
        <div className="sui-flex sui-flex-col sui-gap-2 ">
          {generatePromoLink({
            link: 'https://www.homedepot.com/SpecialBuy/SpecialBuyOfTheDay',
            img: 'https://assets.homedepot-static.com/images/v1/Value-Pricing-Special-Buy.svg',
            text: 'Special Buy of the Day'
          })}
          {generatePromoLink({
            link: 'https://www.homedepot.com/SpecialBuy/ProSpecialBuyOfTheWeek',
            img: 'https://assets.homedepot-static.com/images/v1/Value-Pricing-Special-Buy.svg',
            text: 'Pro Special Buy of the Week'
          })}
          {generatePromoLink({
            link: 'https://www.homedepot.com/b/New-Lower-Prices/N-5yc1vZ1z11adg',
            img: 'https://assets.homedepot-static.com/images/v1/Value-Pricing-New-Lower-Price.svg',
            text: 'New Lower Price'
          })}
          {generatePromoLink({
            link: 'https://www.homedepot.com/c/bulk_pricing',
            img: 'https://assets.homedepot-static.com/images/v1/Value-Pricing-Bulk-Price.svg',
            text: 'Bulk Price Savings'
          })}
        </div>
      </CardContent>
      <CardActions position="end">
        <Button href="https://www.homedepot.com/c/Savings_Center" variant="secondary" fullWidth>
          Shop All Savings
        </Button>
      </CardActions>
    </Card>
  );
};

export { PromotionFallback };
